import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes.base};
    line-height: 1.6;
    color: ${theme.colors.text.black};
    background-color: ${theme.colors.white};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.bold};
    line-height: 1.2;
    color: ${theme.colors.text.black};
  }

  h1 {
    font-size: ${theme.fontSizes['5xl']};
    font-weight: ${theme.fontWeights.black};

    @media (max-width: ${theme.breakpoints.tablet}) {
      font-size: ${theme.fontSizes['4xl']};
    }
  }

  h2 {
    font-size: ${theme.fontSizes['4xl']};
    font-weight: ${theme.fontWeights.bold};

    @media (max-width: ${theme.breakpoints.tablet}) {
      font-size: ${theme.fontSizes['3xl']};
    }
  }

  h3 {
    font-size: ${theme.fontSizes['3xl']};
    font-weight: ${theme.fontWeights.semibold};

    @media (max-width: ${theme.breakpoints.tablet}) {
      font-size: ${theme.fontSizes['2xl']};
    }
  }

  p {
    margin-bottom: ${theme.spacing.md};
    color: ${theme.colors.text.darkGray};
  }

  a {
    color: ${theme.colors.primary.main};
    text-decoration: none;
    transition: color ${theme.transitions.fast};

    &:hover {
      color: ${theme.colors.primary.dark};
    }
  }

  button {
    font-family: ${theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  ul, ol {
    list-style: none;
  }

  input, textarea {
    font-family: ${theme.fonts.primary};
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.neutral[100]};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.primary.main};
    border-radius: ${theme.borderRadius.full};

    &:hover {
      background: ${theme.colors.primary.dark};
    }
  }
`;
